module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style4/cards-style4.component.scss
// module id = ./src/app/features/cards/cards-style4/cards-style4.component.scss
// module chunks = main